/**
 * Heat Loss Calculator
 * ===
 * Simple room heat loss calculator for Stelrad.
 *
 * Author: Duncan McMillan
 *
 * Copyright (c) August 2024 · Art & Soul Communications Ltd.
 * https://artandsoul.co.uk
 *
 */

'use strict';

import _ from 'underscore';
import Backbone from 'backbone';

import { HeatLossCalculator } from './HeatLossCalculator.Object.js';
import { AppView } from './backbone.views/AppView.js';

HeatLossCalculator.vent = _.clone(Backbone.Events); // Event aggregator

HeatLossCalculator.app = undefined;

// --------------------------------------------------
// Start
// --------------------------------------------------

$.HeatLossCalculator = HeatLossCalculator;

/**
 * Kick off the app...
 *
 */
(function($) {
    
    $.fn.hlcapp = function(options) {
        
        Backbone.$ = $;
        
        options = options || {};
        
        options.el = this;
        
        HeatLossCalculator.app = new AppView(options);
    };
    
})(jQuery);